
window.RyftPayParentFormViewController = class RyftPayParentFormViewController {


    PaymentFeed = class PaymentFeed {
        feedId = "";
        paymentAmount = "";
        currency = "";
        first_name = "";
        last_name = "";
        email = "";
        phone = "";
        address_line1 = "";
        address_line2 = "";
        address_city = "";
        address_state = "";
        address_zip = "";
        address_country = "";

    }

    formId = 0;
    submitText = "";
    /** @type {PaymentFeed[]} */
    feeds = [];
    /** @type {PaymentFeed|null} */
    activeFeed = null;


    /** @type {HTMLElement} */
    wrapper;
    /** @type {HTMLFormElement} */
    form;
    /** @type {RyftPayPaymentFormViewController|null} */
    paymentFormViewController = null;
    paymentSessionId = "";

    defaultSubmit = {
        value: "",
        defaultValue: "",
        innerHTML: "",
    }

    /**
     *
     * @param {any} params
     */
    constructor(params) {

        this.formId = parseInt(params.formId ?? 0);
        const fromFeeds = params.feeds ? params.feeds : {};
        for(let entryKey in fromFeeds) {
            const fromFeed  = fromFeeds[entryKey];
            const feed  = new this.PaymentFeed();
            for(let itemKey in fromFeed) {
                feed[itemKey] = (fromFeed[itemKey] ?? "").toString();
            }
            this.feeds.push(feed);
        }
        this.submitText = params.submitText ?? "";

        this.form = document.querySelectorAll("form#gform_"+this.formId)[0] ?? null;
        if(!this.form){
            return;
        }
        const ryft_pay_entry_unique_id = params.ryft_pay_entry_unique_id ?? "";
        const ryftPayInitParams = params.ryftPayInitParams ?? null;
        const paymentFormLocation = params.paymentFormLocation ?? null;
        const embeddedJavascriptSRC = params.embeddedJavascriptSRC ?? null;
        const pluginPath = params.pluginPath ?? null;
        const isSandbox = !!params.isSandbox;
        const ajaxurl = params.ajaxurl;
        const ryft_pay_submission_nonce = params.ryft_pay_submission_nonce;
        this.paymentSessionId = params.paymentSessionId ?? "";


        const additionalValues = {
            ryft_pay_entry_unique_id: ryft_pay_entry_unique_id
        }
        this.addAdditionalFieldValues(additionalValues);

        this.checkForRyftFeeds();
        if(ryftPayInitParams){
            this.showPaymentForm(ryftPayInitParams, paymentFormLocation, embeddedJavascriptSRC, ajaxurl, pluginPath, ryft_pay_submission_nonce, isSandbox);
        }

    }

    disable(){
        this.activeFeed = null;
        this.updateSubmitText();
    }


    /**
     *
     * @param {PaymentFeed} activeFeed
     */
    enable(activeFeed){
        const wasEnabled = !!this.activeFeed;
        this.activeFeed = activeFeed;
        if(wasEnabled){
            return;
        }
       // this.applyTestValues();
        this.updateSubmitText();
    }

    applyTestValues(){

        const activeFeed  = this.activeFeed;
        if(!activeFeed ){
            return;
        }

        const paymentAmountElement = this.getInput(activeFeed.paymentAmount, true);
        const currencyElement = this.getInput(activeFeed.currency);
        const firstNameElement = this.getInput(activeFeed.first_name);
        const lastNameElement = this.getInput(activeFeed.last_name);
        const emailElement = this.getInput(activeFeed.email);
        const phoneElement = this.getInput(activeFeed.phone);
        const addressLine1Element = this.getInput(activeFeed.address_line1);
        const addressLine2Element = this.getInput(activeFeed.address_line2);
        const addressCityElement = this.getInput(activeFeed.address_city);
        const addressStateElement = this.getInput(activeFeed.address_state);
        const addressZipElement = this.getInput(activeFeed.address_zip);
        const addressCountryElement = this.getInput(activeFeed.address_country);

        if(paymentAmountElement){
            paymentAmountElement.value = "£ 123.45";
        }
        if(currencyElement){
            currencyElement.value = "GBP";
        }
        if(emailElement){
            emailElement.value = "aaa@aaa.aaa"
        }
        if(phoneElement){
            phoneElement.value = "07123 456789";
        }
        if(firstNameElement){
            firstNameElement.value = "Test";
        }
        if(lastNameElement){
            lastNameElement.value = "Test";
        }
        if(addressLine1Element){
            addressLine1Element.value = "Test";
        }
        if(addressLine2Element){
            addressLine2Element.value = "";
        }
        if(addressCityElement){
            addressCityElement.value = "Test";
        }
        if(addressStateElement){
            addressStateElement.value = "England";
        }
        if(addressZipElement){
            addressZipElement.value = "se25 5lb";
        }
        if(addressCountryElement){
            addressCountryElement.value = "United Kingdom";
        }
    }

    checkForRyftFeeds(){

        gform.addAction('gform_frontend_feeds_evaluated', async  (fromFeeds, formId) => {
            if (formId !== this.formId) {
                return;
            }
            let activeFeed = null;
            for(let fromFeed of fromFeeds){

                const isActivated = !!((fromFeed.isActivated) ?? false);
                if(!isActivated){
                    continue;
                }

                const feedId = (fromFeed.feedId ?? "").toString();
                for(let feed of this.feeds){
                    if(feed.feedId === feedId){
                        activeFeed = feed;
                        break;
                    }
                }

            }
            if(!activeFeed){
                if(this.activeFeed){
                    this.disable();
                }
            } else if(!this.activeFeed){
                this.enable(activeFeed);
            } else if(this.activeFeed !== activeFeed){
                this.activeFeed = activeFeed;
            }
        });
    }

    /**
     *
     * @param {any} ryftPayInitParams
     * @param {string} paymentFormLocation
     * @param {string} embeddedJavascriptSRC
     * @param {string} ajaxurl
     * @param {string} pluginPath
     * @param {string} ryft_pay_submission_nonce
     * @param {boolean} isSandbox
     */
    showPaymentForm(ryftPayInitParams, paymentFormLocation,embeddedJavascriptSRC, ajaxurl, pluginPath, ryft_pay_submission_nonce, isSandbox){

        if(!paymentFormLocation){
            this.submitCancel("No payment form");
            return;
        }

        const xhr = new XMLHttpRequest();
        xhr.open('GET', paymentFormLocation, true);
        xhr.onreadystatechange= () => {
            if(xhr.readyState !== 4){
                return;
            }
            if(xhr.status !== 200){
                this.submitCancel("Could not load payment form ("+xhr.status+")");
                return;
            }
            let paymentWindow = document.createElement("div");
            paymentWindow.innerHTML = xhr.responseText;
            this.form.parentNode.insertBefore(paymentWindow, this.form);
            this.form.classList.add("hidden");
            this.paymentFormViewController = new RyftPayPaymentFormViewController(ryftPayInitParams, this.paymentSessionId, paymentWindow, this, embeddedJavascriptSRC, ajaxurl, pluginPath, ryft_pay_submission_nonce, isSandbox);
            window.ryftPayViewController = this.paymentFormViewController;
            document.dispatchEvent(new CustomEvent('ryft-pay.payment-window-loaded', {detail: {paymentWindow: paymentWindow, viewController: this.paymentFormViewController}}));
        };
        xhr.send();

    }


    addAdditionalFieldValues(additionalValues)
    {
        for(let key in additionalValues){

            const input = document.createElement('input');
            input.setAttribute('name', key);
            input.setAttribute('value', additionalValues[key]);
            input.setAttribute('type', "hidden")
            this.form.appendChild(input);
        }
    }

    submitForm()
    {
        this.addAdditionalFieldValues();

        this.form.submit();
    }

    /**
     *
     * @param {string|string[]} messages
     */
    submitCancel(messages){
        messages = messages ? (Array.isArray(messages) ? messages : [messages]) : [];
        const additionalValues = {
            ryft_did_cancel: 1
        }
        if(messages.length){
            additionalValues.ryft_messages = JSON.stringify(messages);
        }
        this.addAdditionalFieldValues(additionalValues);
        this.submitForm();
    }

    submitSuccess()
    {
        const additionalValues = {
            ryft_pay_payment_session_id: this.paymentSessionId
        }
        this.addAdditionalFieldValues(additionalValues);
        this.submitForm();
    }

    updateSubmitText(){
        const updateText = () => {
            /** @type {HTMLInputElement|null} */
            let submitButton = null;
            if(this.form){
                const submitButtons = this.form.querySelectorAll('[type="submit"]')
                for(let checkSubmitButton of submitButtons){
                    if(checkSubmitButton.dataset.submissionType === "submit"){
                        submitButton  = checkSubmitButton;
                    }
                }
            }

            if(!submitButton || !this.submitText){
                return;
            }
            if(submitButton.value !== this.submitText){
                this.defaultSubmit.value = submitButton.value;
            }
            if(submitButton.defaultValue !== this.submitText){
                this.defaultSubmit.defaultValue = submitButton.defaultValue;
            }
            if(submitButton.innerHTML !== this.submitText){
                this.defaultSubmit.innerHTML = submitButton.innerHTML;
            }
            const isSubmitRyftPay = !!this.activeFeed;
            if(isSubmitRyftPay){
                submitButton.value = this.submitText;
                submitButton.defaultValue = this.submitText;
                submitButton.innerHTML = this.submitText;
            } else {
                submitButton.value = this.defaultSubmit.value;
                submitButton.defaultValue = this.defaultSubmit.defaultValue;
                submitButton.innerHTML = this.defaultSubmit.innerHTML;
            }
        }
        updateText();
        setTimeout(updateText, 1)
    }

    /**
     *
     * @param {string} id
     * @param {boolean=} isInputContainer
     * @returns {string|null}
     */
    getFieldID(id, isInputContainer) {
        const appliedID = this.formId+"_"+id.split(".").join("_");
        return !isInputContainer ? "field_"+appliedID : "input_"+appliedID+"_container";
    }

    /**
     *
     * @param {string} id
     * @returns {string|null}
     */
    getInputName(id) {
        return "input_"+id;
    }


    /**
     *
     * @param {string} querySelector
     * @returns {HTMLElement|null}
     */
    getElement(querySelector) {
        return this.form.querySelectorAll(querySelector)[0] ?? null;
    }

    /**
     *
     * @param {string} id
     * @returns {HTMLElement|null}
     */
    getField(id) {
        let field =  this.getElement("#"+this.getFieldID(id)) ?? null;
        if(!field){
            field =  this.getElement("#"+this.getFieldID(id, true)) ?? null;
        }
        return field
    }

    /**
     *
     * @param {string} id
     * @param {boolean=} isPrice
     * @returns {HTMLInputElement|null}
     */
    getInput(id, isPrice) {
        if(isPrice){
            const field = this.getField(id);
            const input = field?.querySelectorAll("input.ginput_amount")[0] ?? null;
            if(input){
                return input;
            }
        }
        return this.getElement("[name='"+this.getInputName(id)+"']") ?? null;
    }

    /**
     *
     * @param {string} id
     * @returns {string|null}
     */
    getInputValue(id) {
        return this.getInput(id)?.value ?? null;
    }


}